// extracted by mini-css-extract-plugin
export default {"approveAdvancement":"OptionsFab__approveAdvancement___e35NY"};